import { Modal, ModalBody } from 'reactstrap';
import { IAssetTableData } from '@/interfaces/assets.model';
import { handleAssetRequestStatus } from '@/utility/CommonFunctions';
import moment from 'moment';

interface IAssetRequestDetailModalProps {
  isOpen: boolean;
  toggle: () => void;
  data: IAssetTableData | null;
}

const AssetRequestDetailModal = ({
  isOpen,
  toggle,
  data,
}: IAssetRequestDetailModalProps) => {
  const details = [
    { label: 'Asset Category', value: data?.assetCategory },
    { label: 'Asset Name', value: data?.asset },
    { label: 'Requested By', value: data?.requestedBy },
    { label: 'Requested On', value: data?.requestedOn },
    { label: 'Requirements', value: data?.requirements },
    ...(data?.isTransfer
      ? [
          {
            label: 'Transfer On',
            value: moment(data?.receivedAt).format('DD MMM YYYY'),
          },
        ]
      : []),
    ...(data?.isReturn
      ? [
          {
            label: 'Return On',
            value: moment(data.updatedAt).format('DD MMM YYYY'),
          },
        ]
      : []),
    {
      label: 'Status',
      value: handleAssetRequestStatus(data?.assetRequestStatus ?? 0),
    },
  ];

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      size="lg"
      id="assetRequestDetailModal"
    >
      <div className="modal-header p-4">
        <h1 className="modal-title fs-3 rajdhani-semibold">
          Asset Request Details
        </h1>
        <button type="button" className="btn-close" onClick={toggle} />
      </div>
      <ModalBody className="p-4">
        <ul className={'row list-unstyled mt-4 row-gap-4'}>
          {details?.length > 0 &&
            details?.map((detail, index) => (
              <li key={index} className="col-12 col-md-6 col-lg-4">
                <p className="text-dark">
                  <span className="fs-4 d-block">{detail.label} :-</span>
                  {detail.value || '--'}
                </p>
              </li>
            ))}
        </ul>

        <div className="mt-4 d-flex justify-content-end">
          <button type="button" className="btn btn-danger" onClick={toggle}>
            Cancel
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AssetRequestDetailModal;
